// Caché del HISTORIAL de órdenes en el navegador (IndexedDB) — 29/10/2026.
// Cada apertura del admin bajaba las ~5.200 órdenes entregadas/canceladas/stock (~4 MB): con
// varias personas abriendo el admin muchas veces por día se pasó la cuota de transferencia del
// plan de Supabase (bloqueo 402 el 07/08 y el 29/10). Con la caché se baja solo lo que cambió
// (updated_at > último visto). La caché vence a los 3 días (red de seguridad contra borrados
// duros, que el delta no ve) y es por usuario de Supabase. Si IndexedDB no está disponible
// (navegación privada, etc.) todo sigue andando como antes.
const DB = 'krilic-admin';
const STORE = 'cache';
const KEY = 'orders-history-v1';
export const ORDERS_CACHE_TTL_MS = 3 * 24 * 3600 * 1000;

export interface OrdersHistoryCache { userId: string; savedAt: number; maxUpdated: string | null; rows: any[] }

function open(): Promise<IDBDatabase | null> {
    return new Promise(resolve => {
        try {
            if (typeof indexedDB === 'undefined') return resolve(null);
            const req = indexedDB.open(DB, 2); // v2: recrea el store si quedó una DB sin él
            req.onupgradeneeded = () => { if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE); };
            req.onsuccess = () => resolve(req.result);
            req.onerror = () => resolve(null);
        } catch { resolve(null); }
    });
}

export async function readOrdersHistory(userId: string): Promise<OrdersHistoryCache | null> {
    const db = await open();
    if (!db) return null;
    return new Promise(resolve => {
        try {
            const r = db.transaction(STORE, 'readonly').objectStore(STORE).get(KEY);
            r.onsuccess = () => {
                const v = r.result as OrdersHistoryCache | undefined;
                if (!v || v.userId !== userId || !Array.isArray(v.rows) || Date.now() - v.savedAt > ORDERS_CACHE_TTL_MS) return resolve(null);
                resolve(v);
            };
            r.onerror = () => resolve(null);
        } catch { resolve(null); }
    });
}

export async function writeOrdersHistory(v: OrdersHistoryCache): Promise<void> {
    const db = await open();
    if (!db) return;
    try { db.transaction(STORE, 'readwrite').objectStore(STORE).put(v, KEY); } catch { /* sin caché */ }
}

export async function clearOrdersHistory(): Promise<void> {
    const db = await open();
    if (!db) return;
    try { db.transaction(STORE, 'readwrite').objectStore(STORE).delete(KEY); } catch { /* nada */ }
}
